import { createTestIds } from '../../utils';

export const getTreeTestIds = createTestIds('tree', [] as const);

export const getStandardTreeTestIds = createTestIds('standard-tree', [] as const);
